import React, { useState, useEffect } from 'react';
import ScraperHeader from './ScraperHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Card } from '@mui/material';
import Footer from 'src/components/Footer';
import ScraperContent, { ScrappedItem } from './ScraperContent';
import { API } from '../../../config/config';


const Scrapper = () => {
  const [scrappedData, setScrappedData] = useState<ScrappedItem[]>([]);
  const [isExtConnected, setConnection] = useState(false);
  // create the state for the sorting and filtering here and pass it as a prop to OrdersHeader so it will reflect:
  // Fetch Orders

  useEffect(()=> {
    // Set a Window post message to query the extension for the information
    window.postMessage('wxt-information');

    window.onmessage = (ev: MessageEvent<any>) => {
      const data = (ev.data);
      if(data.type === 'wxt-information') {
        if(data.data.connected) {
          setConnection(true);
        } else {
          setConnection(false);
        }
      }

      if(data.type === 'scrapped-data') {
        if(data.data) {
          // Convert object to array

          setScrappedData(Object.values(data.data));
        }
      }
   }


  },[]);

  return (
    <>
      <title>Orders</title>
      <PageTitleWrapper>
        <ScraperHeader  connected={isExtConnected}/>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <ScraperContent
                scrappedData={scrappedData}

              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default Scrapper;
